import React, { useContext, useEffect, useState, useRef } from "react";
import { Col, Row, Input, Button } from "reactstrap";
import { Field, Numeric } from "../Field/Field";
import { Dispatch } from "../store/store";
import { commissionSuffix } from "../../FundOrder/Form/commons";
import { CommissionType } from "../../../../utils";
import style from "./GoalSeek.module.scss";

const goalSeekResponseInitialValue = {
  cleanPrice: 0,
  tir: 0,
  dirtyPrice: 0,
};

const targetInitialValue = 0;

const GoalSeek = ({ order, fetchCalculatorDataForOffers, fetchGetCalculator, sendDirtyPrice }) => {
  const [targetTNA, setTargetTNA] = useState(targetInitialValue);
  const [goalSeekResponse, setGoalSeekResponse] = useState(goalSeekResponseInitialValue);
  const [reachedStatus, setReachedStatus] = useState("Waiting...");
  const assetInfo = order && order.OrderAssetData && order.OrderAssetData.items;
  const abortControllerRef = useRef(null);

  useEffect(() => {
    // Cleanup function to abort any pending requests when component unmounts
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const isValidOrderData = () => order && order.OrderQuantity && order.AssetId && order.OrderInitDate;

  const handleChangeTargetTNA = (newValue) => {
    setTargetTNA(parseFloat(newValue));
    goalSeekRequestHandler(parseFloat(newValue));
  };

  const isTNAEqualsCoupon = (TNA) => {
    return assetInfo && TNA == parseFloat(assetInfo.Coupon);
  };

  const processTnaEqualsCoupon = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort(); // Cancel the previous request if it exists
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    const request = {
      assetId: order.AssetId,
      quantity: order.OrderQuantity,
      date: new Date().toISOString().slice(0, 10),
      price: 100,
      priceisclean: true,
      priceisdirty: false,
      ytm: true,
    };

    setReachedStatus("Fetching...");

    fetchGetCalculator(request, { signal: controller.signal }).then((response) => {
      if (!response) return;

      if (response.result.Code == 200) {
        setGoalSeekResponse({
          cleanPrice: response.calculator.cleanprice,
          dirtyPrice: response.calculator.dirtyprice,
          tir: response.calculator.ytm,
        });
        sendDirtyPrice(response.calculator.dirtyprice);
        setReachedStatus("Completed");
      } else {
        setReachedStatus("Not Reached");
        setGoalSeekResponse(goalSeekResponseInitialValue);
        return;
      }
    });
  };

  const goalSeekRequestHandler = (TNA) => {
    if (!isValidOrderData()) {
      return;
    }

    if (isTNAEqualsCoupon(TNA)) {
      processTnaEqualsCoupon();
      return;
    }

    if (abortControllerRef.current) {
      abortControllerRef.current.abort(); // Cancel the previous request if it exists
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    const goalSeekRequest = {
      targetValueTNA: TNA,
      assetId: parseInt(order.AssetId),
      quantity: order.OrderQuantity,
      date: order.OrderInitDate,
      isTargetTNA: true,
    };

    setReachedStatus("Fetching...");
    fetchCalculatorDataForOffers(goalSeekRequest, { signal: controller.signal }).then((res) => {
      if (!res || (res.goalSeekResponse && res.goalSeekResponse.Code !== 200)) {
        setReachedStatus("Not Reached");
        setGoalSeekResponse(goalSeekResponseInitialValue);
        return;
      }

      setGoalSeekResponse({
        cleanPrice: res.goalSeekResponse.CleanPrice * 100,
        tir: res.goalSeekResponse.TIR * 100,
        dirtyPrice: res.calculator_out.dirtyprice,
      });

      setReachedStatus("Completed");
      sendDirtyPrice(res.calculator_out.dirtyprice);
    });
  };

  return (
    <div className={style.info}>
      <Row className="mt-1">
        <Col lg={6}>
          <Field label="Target Nominal Rate">
            <Numeric
              value={targetTNA}
              placeholder={"Target Nominal Rate"}
              dataTypeDecimalName={"quantity"}
              onChange={(value) => handleChangeTargetTNA(value)}
              {...commissionSuffix(CommissionType.PrincipalPercentage)}
            />
          </Field>
          <Field label="XIRR">
            <Numeric
              value={goalSeekResponse.tir}
              placeholder={"XIRR"}
              dataTypeDecimalName="quantity"
              disabled={true}
              {...commissionSuffix(CommissionType.PrincipalPercentage)}
            />
          </Field>
        </Col>
        <Col lg={6}>
          <Field label="Dirty Price">
            <Numeric
              value={goalSeekResponse.dirtyPrice}
              placeholder={"Dirty Price Porcentage"}
              dataTypeDecimalName="quantity"
              disabled={true}
            />
          </Field>
          <Field label="Clean Price">
            <Numeric
              value={goalSeekResponse.cleanPrice}
              placeholder={"Clean Price Porcentage"}
              dataTypeDecimalName="quantity"
              disabled={true}
              {...commissionSuffix(CommissionType.PrincipalPercentage)}
            />
          </Field>
        </Col>
        <Col lg={12}>
          <Field label="Reached Status">
            <Input type="text" value={reachedStatus} disabled={true} className={style.sucess} />
          </Field>
        </Col>
      </Row>
    </div>
  );
};

export default GoalSeek;
